import { render, staticRenderFns } from "./JoinChunks.vue?vue&type=template&id=38e3cc27&scoped=true"
import script from "./JoinChunks.vue?vue&type=script&lang=js"
export * from "./JoinChunks.vue?vue&type=script&lang=js"
import style0 from "./JoinChunks.vue?vue&type=style&index=0&id=38e3cc27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3cc27",
  null
  
)

export default component.exports